enum MoveDirectionType {
    TOP = 1,
    BOTTOM = 2,
    LEFT = 3,
    RIGHT = 4,
}

export default MoveDirectionType;